import { ReactComponent as EditIcon } from "../../components/icons/edit_icon.svg";
import { ReactComponent as ShareIcon } from "../../components/icons/share_icon_red.svg";
import { ReactComponent as ManageIcon } from "../../components/icons/manage_icon.svg";

export const getCollectionMenu = ({ actions }: any) => {
  const { onEdit, onShare, onManage } = actions;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: EditIcon,
          title: "Edit",
          onClick: onEdit
        },
        {
          icon: ShareIcon,
          title: "Share",
          onClick: onShare
        },
        {
          icon: ManageIcon,
          title: "Manage",
          onClick: onManage
        }
      ]
    }
  ];
};
